import axios from 'axios';
import { ApplicationPaths } from '../components/api-authorization/ApiAuthorizationConstants';
import authService from '../components/api-authorization/AuthorizeService';
import history from '../history';

const instance = axios.create({
    //baseURL: "api/v1"//process.env.ApiBaseUrl
});

// Request interceptor: adjunta Bearer token
instance.interceptors.request.use(async function (config) {
    const token = await authService.getAccessToken();
    config.headers.Authorization = `Bearer ${token}`;

    return config;
});

// Response interceptor: redirige al login en 401; limpia el centro activo en 403
instance.interceptors.response.use(response => {
    return response;
}, error => {
    switch (error.response?.status) {
        case 401:
            console.log(JSON.stringify(error));
            history.push(ApplicationPaths.Login);
            break;
        case 403:
            // 403 indica falta de permisos para la acción solicitada.
            // No redirigir ni limpiar el centro activo: un error de permiso no implica
            // que el centro sea inválido. La validez del centro se verifica en el bootstrap
            // al iniciar sesión. Los componentes muestran el error vía HandleApiError.
            break;
        default:
            break;
    }

    return Promise.reject(error);
});

export default instance;